module.exports = __webpack_public_path__ + "static/media/radio vlna@2x.f38b14c6.png";